import ServiceBase from './serviceBase';
import { SearchList, SearchFilter } from './types/Search';

class SearchService extends ServiceBase {
  search = async (filter: SearchFilter): Promise<SearchList> => {
    if (!filter.query) {
      return { list: [], from: 0, to: 0, total: 0 };
    }
    return this.post<SearchList>('searches', filter);
  };
}

const searchService = new SearchService();

export default searchService;
